import { createSavedLayerStepLineFeatureStyle } from 'cadenza/map/routing/layer/step-geometry-feature-style';

/**
 * Route line geometry style provider. It's needed for special rendering of route steps in workbook
 *
 * @param {object} style - A style DTO
 * @param {GeometryType} geometryType - A feature geometry type
 * @return {Array[ol.style.Style]} If style has a 'routeLineGeometry' returns a route step styles array, or undefined otherwise.
 */
export function routeStepLineStyleProvider (style, geometryType) {
  if (!('routeStepLineGeometry' in style)) {
    return undefined;
  }
  return createSavedLayerStepLineFeatureStyle(style);
}
